import React from 'react';
import MarketingLandingPage from '../marketing-landing-page/marketing-landing-page';
import type { Region as Props } from './region.types';

const Region: React.FC<Props> = props => <MarketingLandingPage {...props} />;

export default Region;
